import { defineStore } from "pinia";
import { ref } from "vue";

import type { Objective } from "@/model/objective";
import { asReadonly } from "@/utils/vue";

import { useClientSettingsStore } from "./clientSettings";

export const useArtObjectivesPanelStore = defineStore("artObjectivesPanel", () => {
  const active = ref(false);
  // ID of the ART objective the user clicked in the side panel; while
  // pinned, the main board dims team objectives not linked to it. Cleared
  // when the user leaves the ART objectives board.
  const pinnedArtObjectiveId = ref<string | null>(null);

  return {
    active: asReadonly(active),
    pinnedArtObjectiveId: asReadonly(pinnedArtObjectiveId),

    isTeamObjectiveLinkedToPinned: (objective: Objective) => {
      if (pinnedArtObjectiveId.value === null) return true;
      return objective.linkedObjectives.some((l) => l.id === pinnedArtObjectiveId.value);
    },
    // User toggle (TopLeftMenu button): flip and persist the preference.
    toggle: () => {
      active.value = !active.value;
      useClientSettingsStore().setArtObjectivesPanelOpen(active.value);
    },
    // Hide the panel and optionally persist the preference.
    close: (persist: boolean) => {
      active.value = false;
      if (persist) useClientSettingsStore().setArtObjectivesPanelOpen(false);
    },
    // Apply the saved preference from the store.
    restore: () => {
      active.value = useClientSettingsStore().artObjectivesPanelOpen;
    },
    togglePin: (id: string) =>
      (pinnedArtObjectiveId.value = pinnedArtObjectiveId.value === id ? null : id),
    unpin: () => (pinnedArtObjectiveId.value = null),
    setPin: (id: string | null) => (pinnedArtObjectiveId.value = id),
  };
});
